import script from "./ProjectListNavMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectListNavMenu.vue?vue&type=script&setup=true&lang=js"

import "./ProjectListNavMenu.vue?vue&type=style&index=0&id=65d4d40f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d4d40f"]])

export default __exports__